// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__OY7sy","containerItemsCenter":"Skeleton_containerItemsCenter__1Tmfd"};